import RTL_LANGUAGES from "core/constants/language/rtlLanguages"

const isRTL = language => RTL_LANGUAGES.includes(language.toLowerCase())

export default isRTL;